// Initialize tooltips
const $ = require("jquery");

function createTooltips() {
  $('[data-toggle="tooltip"]').tooltip();
}

module.exports = {
  onLoad: createTooltips
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-tooltips/booking-tooltips.js